export class mdlCheckPaymentStatusReq{
    public ProposalNo: string;
    public MerchentReferenceNo: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlCheckPaymentStatusReq.ts